import React from "react";
import "../src/assets/icofont/icofont.css";
import "./App.css";
import "font-awesome/css/font-awesome.css";

import Hero from "./components/Hero";
import Header from "./components/Header";
import About from "./components/About";
import Services from "./components/Services";
import Testimonial from "./components/Testimonial";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { ThemeProvider } from "styled-components";
import Theme from "./components/Theme/theme";

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={Theme}>
        <Header />
        <Hero />
        <About />
        <Services />
        <Testimonial />
        <Contact />
        <Footer />
      </ThemeProvider>
    </div>
  );
}

export default App;
